<template>
  <article>
    <section class="w-full">
      <div class="banner w-full lg:h-18 h-60 relative">
        <div class="flex items-center flex-column w-full h-full">
          <div class="container mx-auto">
            <div class="flex flex-col items-center w-full container">
              <divider-component>Services</divider-component>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="w-full h-48 flex items-center flex-col -mt-6 md:mb-16">
      <div class="md:w-3/4 w-full h-full flex items-center justify-evenly">
        <service-card-component :title="'WiFi'" :description="'WiFi doorheen heel de zaak!'">
          <fa :icon="['fas', 'wifi']"></fa
        ></service-card-component>

        <service-card-component
          :title="'Parking'"
          :description="' Parking achter- en vooraan de zaak!'"
        >
          <fa :icon="['fas', 'parking']"></fa>
        </service-card-component>

        <service-card-component
          :title="'Cadeaubonnen'"
          :description="'Cadeaubonnen kunnen hier gebruikt worden'"
        >
          <fa :icon="['fas', 'gift']"></fa>
        </service-card-component>
      </div>
      <informational-text-component class="md:mt-8 mt-6">
        Voor meer informatie omtrent WiFi en cadeaubonnen kan je dat altijd vragen aan de dames in
        de zaak!
      </informational-text-component>

      <p class="text-sm italic my-12"></p>
    </section>
    <section class="w-full flex flex-col items-center justify-center md:px-0 px-2">
      <service-box-component :is-right="false" :image-name="'Sandwhichmand.png'">
        <h1 class="font-bold md:text-xl text-md mb-2">Feestje?</h1>
        <div class="bg-orange-200 h-px w-8/12 my-1"></div>
        <p class="md:text-md text-sm flex flex-col mt-2">
          Heeft u een vergadering, een receptie of een feestje?
          <span> Wij zorgen met plezier voor een lekker broodje of zoete hap. </span>
        </p>
      </service-box-component>
      <service-box-component :is-right="true" :image-name="'Broodjesmand.png'">
        <h1 class="font-bold md:text-xl text-md mb-2">Talloze mogelijkheden</h1>
        <div class="bg-orange-200 h-px w-8/12 my-1"></div>
        <p class="md:text-md text-sm mt-2">
          Keuze uit verschillende soorten beleg. Alles wordt mooi gepresenteerd in broodmanden of op
          plateaus.
        </p>
        <div class="flex flec-col mt-6 ml-4">
          <ul class="md:text-md text-sm list-disc">
            <li>Open belegde broodjes</li>
            <li>Mini-sandwinos</li>
          </ul>
          <ul class="md:text-md text-sm list-disc ml-8">
            <li>Mini-koffiekoekjes</li>
            <li>Mini-donutjes</li>
          </ul>
        </div>
      </service-box-component>

      <service-box-component :is-right="false" :image-name="'gallery-image1.jpeg'">
        <h1 class="font-bold md:text-xl text-md mb-2">Meer informatie?</h1>
        <div class="bg-orange-200 h-px w-8/12 my-1"></div>

        <p class="md:text-md text-sm mt-2 flex flex-col">
          Wenst u meer informatie over onze feestmanden, stuur ons even een mailtje of kom gewoon
          even langs.
          <span>Wij maken graag met u een afspraak om de details te bespreken.</span>
        </p>
      </service-box-component>
    </section>
  </article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DividerComponent from '@/components/util/Divider.component.vue';
import ServiceCardComponent from '@/components/services/Service-card.component.vue';
import informationalTextComponent from '@/components/util/informational-text.component.vue';
import ServiceBoxComponent from '@/components/services/Service-box.component.vue';
export default defineComponent({
  name: 'Services-page',
  components: {
    DividerComponent,
    ServiceCardComponent,
    informationalTextComponent,
    ServiceBoxComponent,
  },
});
</script>

<style lang="scss" scoped>
.image-shadow {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}
</style>
